<template>
  <div class="comment">
    <h2>我要评论</h2>
	<div class="textarea_box">
		<textarea
		  name=""
		  id=""
		  v-model="cmsg"
		  maxlength="255"
		  @input="descInput"
		  placeholder="请输入你要评论的内容"
		></textarea>
		<span class="coment_count">{{remnant}}/255字</span>
	</div>
    <div class="comment_btn">
      <span @click="addCommon">发表</span>
    </div>
    <div class="comment_line"></div>
    <commentList :list="commentList" @loadMore="loadMore"></commentList>
  </div>
</template>

<script>
import { getCommonList, addCommon } from "../api/information";
import commentList from "../components/commentList";
import {getToken} from "@/utils/auth"

export default {
  // props: {
  //   id: {
  //     type: Number,
  //   },
  // },
  components: {
    commentList,
  },
  data() {
    return {
      cmsg: "",
      commentList:[],
      curPage:1,
      totalPage:"",
      limit:5,
	    remnant:0
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getCommonList();
  },
  methods: {
	//计算字数
	descInput(){
	  this.remnant = this.cmsg.length;
	  if(this.remnant >254){
		 this.$message({
		   	message:'评论的字数超过了限制哦',
		     type:'warning'
		 });
		 return false;
	  }
	},
    //加载更多
    loadMore(){
       if(this.curPage>= this.totalPage){
         this.$message({
			 message:'已经到底了',
			 type:'info',
			 duration:1000
		 });
       }
       this.curPage = this.curPage + 1;
       this.getCommonList();
    },
    //获取评价列表
    getCommonList() {
      getCommonList({
        curPage: this.curPage,
        limit: this.limit,
        iid: this.id,
        type: 0,
      }).then((res) => {
        if(this.curPage>1){
           this.commentList = this.commentList.concat(res.page.list);
        }else{
           this.commentList = res.page.list;
        }
        this.totalPage = res.page.totalPage;
      });
    },
    //发表评价
    addCommon() {
     if(getToken()!= undefined){
        if (!this.cmsg) {
        this.$message({
          message: "评论不得为空",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      addCommon({
        cmsg: this.cmsg,
        iid: this.id,
        type: 0,
        userid: 5,
      }).then((res) => {
        this.curPage = 1;
        this.commentList = [];
        this.cmsg = "";
        this.$message({
        message: "发表评价成功，积分+1",
        type: "success",
        duration: 1000,
        onClose: (res) => {
        this.getCommonList();
        },
        });
        this.remnant =0
      });
     }else{
       this.$router.replace('/login')
     }
    },
  },
};
</script>

<style scoped lang='less'>
.comment {
  h2 {
    position: relative;
    padding-left: 15px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    &::before {
      position: absolute;
      left: 0;
      bottom: 3px;
      display: inline-block;
      content: "";
      width: 5px;
      height: 24px;
      background: #ff7302;
    }
  }
  textarea {
    width: 100%;
    height: 150px;
    padding: 15px 10px;
    margin: 15px 0;
    resize: none;
    background: #eeeeee;
  }
  .comment_btn {
    text-align: right;
    span {
      display: inline-block;
      cursor: pointer;
      // float: right;
      width: 15%;
      text-align: center;
      padding: 10px 0;
      background: #ff7302;
      border-radius: 3px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .comment_line {
    width: 100%;
    height: 1px;
    margin: 10px 0;
    background: #eeeeee;
  }
}
.textarea_box{
	position: relative;
}
.coment_count{
  position:absolute;
  top: 75%;
  right: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  z-index: 100 !important;
}
</style>


// WEBPACK FOOTER //
// src/common/comment.vue